export const lpad = (num, size) => ('000000000' + num).slice(-size);